const theme = {
  // MARK: 동일 컬러 내에서 연한 것부터 진한 것까지 순서대로 정렬
  white: "#FFFFFF",
  gray1: "#F8F8F8",
  gray2: "#EEEEEE",
  gray3: "#B6B6B6",
  gray4: "#7D7D7D",
  gray5: "#4C4C4C",
  black: "#2F2F2F",
  yellow1: "#FFF4CC",
  yellow2: "#FFE380",
  yellow3: "#FFC700",
};

export default theme;
